import { render, staticRenderFns } from "./OrderBoxLlevar.vue?vue&type=template&id=e71d9e7c&scoped=true&"
import script from "./OrderBoxLlevar.vue?vue&type=script&lang=js&"
export * from "./OrderBoxLlevar.vue?vue&type=script&lang=js&"
import style0 from "./OrderBoxLlevar.vue?vue&type=style&index=0&id=e71d9e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71d9e7c",
  null
  
)

export default component.exports